// extracted by mini-css-extract-plugin
export var csatScore = "_ns-5";
export var header = "_ns-1";
export var panelWrapper = "_ns-2";
export var postPreview = "_ns-3";
export var rightContent = "_ns-0";
export var wrappingText = "_ns-4";